import React, { createContext, useState, useContext, useEffect } from 'react';

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
    const [projectsFolder] = useState([
        "JEUX PARALYMPIQUES GAME IS NOT OVER",
        "JEUX PARALYMPIQUES SAUF VOUS",
        "FFF PARIS 2024",
        "NEW BALANCE LIFESTYLE",
        "NEW BALANCE RUNNING",
        "ASSE JERSEY KIT 24-25",
        "NIKE MEMBER WEEK",
        "PUMA X RICHARD ORLINSKI",
        "ADIDAS ZNE",
    ]);

    const [projectsName] = useState([
        "JEUX PARALYMPIQUES - GAME IS NOT OVER",
        "JEUX PARALYMPIQUES - SAUF VOUS",
        "FFF - EURO 2024 & PARIS 2024",
        "NEW BALANCE - LIFESTYLE",
        "NEW BALANCE - RUNNING",
        "HUMMEL x ASSE -  JERSEY KIT 24/25",
        "NIKE - MEMBER WEEK",
        "PUMA - RICHARD ORLINSKI COLLAB",
        "ADIDAS - ZNE",
    ]);

    const [currentHoverProject, setCurrentHoverProject] = useState(undefined);
    const [isSliderLoading, setIsSliderLoading] = useState(false);
    const [currentProject, setCurrentProject] = useState(undefined);
    const [preloadedBackgrounds, setPreloadedBackgrounds] = useState({});
    const [projectDescription, setProjectDescription] = useState("");
    const [projectSliderImages, setProjectSliderImages] = useState([]); // Nouvel état pour les images du slider
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const preloadBackgrounds = async () => {
            const backgroundsMap = {};
            for (let project of projectsFolder) {
                const basePath = `${process.env.PUBLIC_URL}/${project}`;
                const potentialFiles = ["Background.mp4", "Background.jpg", "Background.png"];
                for (let file of potentialFiles) {
                    try {
                        const response = await fetch(`${basePath}/${file}`);
                        if (response.ok) {
                            const contentLength = response.headers.get("Content-Length");
                            if (contentLength && parseInt(contentLength, 10) > 0) {
                                const backgroundSrc = `${basePath}/${file}`;
                                backgroundsMap[project] = backgroundSrc;
                                break;
                            }
                        }
                    } catch (error) {
                        console.error(`Impossible de charger le fichier d'arrière-plan: ${file}`, error);
                    }
                }
            }
            setPreloadedBackgrounds(backgroundsMap);
            setIsLoading(false);
        };
        preloadBackgrounds();
    }, [projectsFolder]);

    useEffect(() => {
        const loadDescriptionAndSlider = async () => {
            if (currentProject) {
                setIsSliderLoading(true);
                const projectFolder = projectsFolder[projectsName.indexOf(currentProject)];
                const basePath = `${process.env.PUBLIC_URL}/${projectFolder}`;
                const descriptionPath = `${basePath}/Description.txt`;
                const sliderPath = `${basePath}/Slider`;

                // Charger la description
                try {
                    const response = await fetch(descriptionPath);
                    if (response.ok) {
                        const text = await response.text();
                        setProjectDescription(text);
                    } else {
                        console.warn(`Description.txt non trouvé pour ${projectFolder}`);
                        setProjectDescription("");
                    }
                } catch (error) {
                    console.error(`Erreur lors du chargement de Description.txt pour ${projectFolder}`, error);
                    setProjectDescription("");
                }

                // Charger les images du slider
                try {
                    const images = [];
                    let index = 1;

                    while (true) {
                        let fileFound = false;
                        for (const ext of ["jpg", "gif", "png", "txt"]) {
                            const filePath = `${sliderPath}/${index}.${ext}`;
                            try {
                                const fileResponse = await fetch(filePath);
                                if (fileResponse.ok) {
                                    const contentType = fileResponse.headers.get("Content-Type");

                                    if (ext === "txt" && contentType && contentType.startsWith("text/")) {
                                        const textContent = await fileResponse.text();
                                        if (textContent.startsWith("https://player.vimeo.com")) {
                                            images.push(textContent); // Ajouter le contenu du fichier texte
                                            fileFound = true;
                                        }
                                        else {
                                            break;
                                        }

                                    } else if (contentType && contentType.startsWith("image/")) {
                                        images.push(filePath); // Ajouter le chemin de l'image
                                        fileFound = true;
                                        break;

                                    } else {

                                        console.warn(`Le fichier n'est pas valide : ${filePath}`);
                                        if (ext === "txt") {
                                            break;
                                        }
                                    }

                                }
                            } catch (error) {
                                console.warn(`Impossible de charger le fichier : ${filePath}`);
                            }
                        }
                        if (!fileFound) {
                            // Si aucun fichier avec cet index n'est trouvé, sortir de la boucle
                            break;
                        }
                        index++;
                    }
                    setIsSliderLoading(false);
                    setProjectSliderImages(images);
                } catch (error) {
                    setIsSliderLoading(false);
                    console.error(`Erreur lors du chargement des fichiers Slider pour ${projectFolder}`, error);
                    setProjectSliderImages([]);
                }
            } else {
                setIsSliderLoading(false);
                setProjectDescription("");
                setProjectSliderImages([]);
            }
        };

        loadDescriptionAndSlider();
    }, [currentProject, projectsFolder, projectsName]);

    return (
        <ProjectContext.Provider
            value={{
                projectsFolder,
                projectsName,
                currentProject,
                setCurrentProject,
                currentHoverProject,
                setCurrentHoverProject,
                preloadedBackgrounds,
                projectDescription,
                projectSliderImages, // Ajout des images du slider au contexte
                isLoading,
                isSliderLoading
            }}
        >
            {children}
        </ProjectContext.Provider>
    );
};

export const useProject = () => {
    const context = useContext(ProjectContext);
    if (!context) {
        throw new Error('useProject must be used within a ProjectProvider');
    }
    return context;
};
